import { DataType, RequestMethod, Result } from '@/typings';
import { fetchResult } from '@/utils';

export const ApplicationService = {
  mapsApiKey: (): Promise<Result<{ key: string }>> => {
    const req = { url: 'ajax-maps-api-key', method: RequestMethod.Get, dataType: DataType.JSON };
    return fetchResult(req);
  },
};
